<div>
    <img src='/assets/images/cvc.png'>
</div>